export default __webpack_public_path__ + "static/media/Hair_11_M_C4.d522085c.svg";